export const exportDocument = ({
  file = null,
  fileName = 'document',
  extension = 'csv'
}) => {
  const url = window.URL.createObjectURL(
    new Blob([file], { type: 'text/plain' })
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.${extension}`;
  document.body.appendChild(link);
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );
  link.remove();
  window.URL.revokeObjectURL(link.href);
};

export default exportDocument;
